module.exports = __webpack_public_path__ + "img/49.751ffa4e.png";